<template>
    <div class="group-handle">
        <span v-show="selectedUserIds.value.length" class="group-handle__info">{{$t('pc_biz_group_select_info', [selectedUserIds.value.length]) /* 已选择 {0} 人 */}}</span>
        <yxt-button v-show="selectedUserIds.value.length" type="text" @click="setPage('Group')">{{$t('pc_biz_group_move_group') /* 移动分组 */}} </yxt-button>
        <yxt-button v-show="groupList.length && selectedUserIds.value.length" type="text" @click="removeMember()">{{$t('pc_biz_group_remove_group') /* 移出小组 */}}</yxt-button>
        <yxt-button v-show="selectedUserIds.value.length" type="text" @click="setSelectUser([])">{{$t('pc_biz_group_cancel_select') /* 取消选择 */}}</yxt-button>
        <yxt-button v-show="selectedUserIds.value.length && action" type="text" @click="deleteUser(selectedUserIds.value)">{{$t('pc_biz_group_batchdel') /* 批量删除 */}}</yxt-button>
    </div>
</template>
<script>
import { Button } from 'yxt-pc';
export default {
  components: {
    'yxt-button': Button
  },
  props: {
    action: {
      type: Boolean,
      default: true
    },
    groupList: {
      type: Array,
      require: true
    }
  },
  inject: {
    selectedUserIds: {
      value: {
        default: []
      }
    },
    reselectUser: {
      default: () => {}
    },
    deleteUser: {
      default: () => {}
    },
    removeMember: {
      default: () => {}
    },
    setPage: {
      default: () => {}
    },
    setSelectUser: {
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.group-handle{
  display: flex;
  align-items: center;

  &__info{
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-right: 12px;
  }
}
</style>
